import React from "react";
import Select, { components } from "react-select";
import './SortFiltersStyles.css';

const customStyles = {
  control: (base) => ({
    ...base,
    height: 29,
    minHeight: 29,
    marginBottom: 5,
    borderColor: "lightgray",
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    paddingTop: 0,
    paddingBottom: 0,
    color: "lightgray",
  }),
  clearIndicator: (styles) => ({
    ...styles,
    paddingTop: 0,
    paddingBottom: 0,
    color: "lightgray",
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: state.isFocused
      ? "var(--light_color_shade)"
      : "none",
    color: state.isFocused ? "#fff" : "none",
  })
};

const ValueContainer = ({ children, ...props }) => {
  let [values, input] = children;

  if (Array.isArray(values)) {
    const plural = values.length === 1 ? "" : "s";
    values = `${values.length} selected`;
  }

  return (
    <components.ValueContainer {...props}>
      {values}
      {input}
    </components.ValueContainer>
  );
};

export default function SortFilters({value, onChangeFunc, options}) {
  // console.log("value",value);
  // console.log("options",options)
  const onChangeSelectedOption = (value) => {
    onChangeFunc(value);
  };

  return (
    <>
      <Select
        className={"multiselect1"}
        onChange={onChangeSelectedOption}
        placeholder="Select Sort"
        options={options}
        isMulti={false}
        value={value}
        components={{ ValueContainer }}
        closeMenuOnSelect={true}
        styles={customStyles}
        hideSelectedOptions={false}
      />
    </>
  );
}
